import { render, staticRenderFns } from "./Trial.vue?vue&type=template&id=db9ce48c&"
import script from "./Trial.vue?vue&type=script&setup=true&lang=js&"
export * from "./Trial.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports